import { Client } from '@optimizely/optimizely-sdk';
import { getUserUuid } from '../util/getUserUuid';

class FeatureService {
  private readonly optimizelyInstance: Client | null;

  constructor() {
    if (!window.optimizelySdk || !window.optimizelyDatafile) {
      const missingPiece = !window.optimizelySdk ? 'optimizelySdk' : 'optimizelyDatafile';

      // eslint-disable-next-line no-console
      console.warn(
        `Failed to instantiate optimizely instance: window.${missingPiece} is undefined`
      );
      this.optimizelyInstance = null;
    } else {
      this.optimizelyInstance = window.optimizelySdk.createInstance({
        datafile: window.optimizelyDatafile,
        logLevel: window.optimizelySdk.enums.LOG_LEVEL.WARNING,
      });
    }
  }

  isActive(
    flagName: string,
    userUuid: string,
    userEmail: string = null,
    automatedTestUser = false,
    fallback = false
  ) {
    if (!this.optimizelyInstance) {
      return fallback;
    }

    const attributes = {
      email: userEmail,
      automatedTestUser,
    };

    return this.optimizelyInstance.isFeatureEnabled(flagName, userUuid, attributes);
  }

  getFeatureVariable<T>(
    flagName: string,
    variableName: string,
    defaultValue: T,
    userUuid = getUserUuid()
  ): T {
    if (!this.optimizelyInstance) {
      return defaultValue;
    }

    return this.optimizelyInstance.getFeatureVariable(flagName, variableName, userUuid) as T;
  }
}

const instance = new FeatureService();

window.__featureService = instance;

export default instance;
